import { apiRequest } from '../utils/apiClient';

export interface SubscriptionPlanFromAPI {
  id: string;
  name: string;
  nameAr: string | null;
  slug: string;
  description: string | null;
  descriptionAr: string | null;
  planType: string;
  priceMonthly: number;
  priceYearly: number;
  currency: string;
  maxListings: number | null;
  maxSubUsers: number | null;
  features: Record<string, unknown>;
  isPopular: boolean;
  sortOrder: number;
  isActive: boolean;
  /** Coins granted to the user when this plan is purchased/renewed. */
  includedCoins: number;
}

export async function fetchPlans(planType?: string): Promise<SubscriptionPlanFromAPI[]> {
  const params = new URLSearchParams();
  if (planType) params.set('planType', planType);

  const result = await apiRequest<{ data: SubscriptionPlanFromAPI[] }>(
    `/subscriptions/plans?${params}`,
    { method: 'GET' },
  );
  return result.data;
}
